export const checkIfResponsiveMediaIsPresent = (responsiveBannerMedia: any) => {
  const isDesktopMediaPresent = responsiveBannerMedia?.desktop?.url?.length > 0;
  const isTabletMediaPresent = responsiveBannerMedia?.tablet?.url?.length > 0;
  const isMobileMediaPresent = responsiveBannerMedia?.squareImage?.url?.length > 0 || responsiveBannerMedia?.mobile?.url?.length > 0;

  return isDesktopMediaPresent && isTabletMediaPresent && isMobileMediaPresent;
};
